export const APP_NAME = 'Promillo';
